import { render } from "./field-label-template.vue?vue&type=template&id=5a3b73ee"
import script from "./field-label-template.vue?vue&type=script&lang=js"
export * from "./field-label-template.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__